module.exports = __webpack_public_path__ + "img/annotation-check.1aac8071.svg";